<div style="width: auto; overflow: auto">
    <app-common-list-table
        [showExportCsv]="this.env.appName === 'donjardin' || this.env.appName === 'coliberica' || this.env.appName === 'demogardengest'"
        [request]="getRequest" [filtering]="filter" [cols]="cols" [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform" [customExportCsv]="env.showTareasBioExportCsv"
        (emitSearchText)="updateFooter()" [actionButtonText]="env.canAddTareas ? btnAnadir : ''"
        (actionButtonClick)="addFertilizante()" (visualize)="show('info', $event)" (edit)="edit($event)"
        (duplicate)="duplicate($event)" (remove)="show('delete', $event)">
        <ng-template #header>
            <div *ngIf="this.env.rol ==='responsable' || this.env.appName === 'benibal'" style="margin-left: 20px;">
                <button class="mx-2 btn" (click)="downloadCsv()"
                    style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white;">
                    <i class="fa fa-download"></i>
                    Exportar listado
                </button>
            </div>
            <div *ngIf="env.appName ==='donjardin' || this.env.appName === 'coliberica' || env.appName === 'demogardengest' || env.showTareasPrioridad "
                style="width: 100%; margin-right: 15px" class="d-flex justify-content-start align-items-center">

                <div style="margin-left: 10px; margin-right: 10px">
                    <div style="font-size: 0.7em" class="btn-group">
                        <button (click)="filtrarTratamientos('aplicados', 'switch_aplicados')"
                            [ngClass]="aplicado.selected === 'aplicados' ? 'btn btn-primary' : 'btn btn-light'" style="
                                            height: 28px;
                                            width: 40px;
                                            border: 1px solid grey;
                                            border-right: 1px solid grey">
                            SÍ
                        </button>
                        <button (click)="filtrarTratamientos('no-aplicados', 'switch_aplicados')"
                            [ngClass]="aplicado.selected === 'no-aplicados' ? 'btn btn-primary' : 'btn btn-light'"
                            style="
                                            height: 28px;
                                            width: 40px;
                                            border: 1px solid grey;
                                            border-right: 1px solid grey">
                            NO
                        </button>
                    </div>
                </div>
                <span style="color: white; margin-top: -0px;">
                    Aplicados
                </span>

                <div style="margin-left: 20px ;display: flex;" *ngIf="env.betweenDates">
                    <app-datepicker (sendFecha)="getFechaInicio($event)">
                    </app-datepicker>
                    <p style="color:white; margin-left: 10px;margin-bottom: 0;">F.Inicio</p>
                </div>
                <div style="margin-left: 20px ;display: flex;" *ngIf="env.betweenDates">
                    <app-datepicker (sendFecha)="getFechaFin($event)">
                    </app-datepicker>
                    <p style="color:white; margin-left: 10px;margin-bottom: 0;">F.Fin</p>
                </div>


            </div>
            <div *ngIf="env.showCampaign" id="campaign">
                <label for="">Campaña</label>
                <p-select [options]="years" [(ngModel)]="env.selectedYears" (onChange)='selectedCampaign()'></p-select>
            </div>
        </ng-template>
        <ng-template #thEnd>
            <!-- <th [style.width]="showPrescripcion ? '150px' : ''"> -->
            <th class="rt-col-actions" style="width: 120px;">
                <p class="d-flex justify-content-center mb-0">Acciones</p>
            </th>
        </ng-template>


        <ng-template #tdEnd let-data>
            <td class="rt-col-actions">
                <div class="w-full d-flex justify-content-center align-items-center gap-4">
                    <app-action-buttons [hideDelete]="false" [showDuplicate]="env.canDuplicateTareas"
                        (duplicateRowButtonEvent)="duplicate(data.data)" (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)"
                        (showRowButtonEvent)="show('info', data.data)">
                    </app-action-buttons>
                    <button *ngIf="showPrescripcion" class="d-flex justify-content-center align-items-center" type="button"
                        (click)="generarReceta(data.data)" tooltipPosition="top"
                        pTooltip="{{this.env.appName === 'yagoaznar' ? 'Plan de Abonado' : 'Receta'}}" style="
                                height: 20px;
                                width: 20px;
                                border: none;
                                border-radius: 3px;
                                background-color: #007b00;
                                color: white;
                                cursor: pointer;">
                        <i class="fa fa-file-pdf-o"></i>
                    </button>
                </div>
            </td>
        </ng-template>

        <ng-template *ngIf="env.showFertilizantesNPK" #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="(['finca'].includes(col.field))">
                TOTAL:
            </div>
            <div style="font-size: 0.75em; text-align: center; font-weight: bold">
                <span *ngIf="(['n','p','k','ca','horas_totales'].includes(col.field))">
                    {{col.footer}}
                </span>
            </div>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals [view]="this" [form]="form?.formFields" [serverUrl]="env.serverUrl" [previousData]="model"
    [recordHasAssociatedData]="false" [getRequest]="getRequest" [deleteRequest]="deleteRequest">
</app-modals>

<!-- VERSIÓN "Pascual Cabedo" -->
<p-dialog *ngIf="env.showRecetaFertiPascualCabedo" header="Generar receta" [(visible)]="showReceta"
    (onShow)="scrollToTop()">

    <div *ngIf="receta" style="margin-left: 20px; margin-right: 20px; width: 80vw !important;">
        <div id="html2canvasDiv" class="registroDiv mx-auto"
            style="font-family: 'Times New Roman', Times, serif; font-size: 12pt; width: 800px;">
            <div class="text-center">
                <img [src]="env.logoUrl" style="width: 220px; height: auto;" alt="Logo" />
            </div>

            <div class="mt-1 mb-4" style="border: 1px solid #8f8f8f; outline: 1px #c5c5c5;">
                <ul class="p-0 m-0 ml-1" style="list-style: none; color: #006600;">
                    <li>
                        <span class="font-weight-bold" style="text-decoration: underline;">FECHA:</span>
                        <span style="color: #0c0c0c; font-family: Arial, Helvetica, sans-serif;">
                            {{receta.fecha_inicio}}
                        </span>
                    </li>
                    <li>
                        <span class="font-weight-bold" style="text-decoration: underline;">CLIENTE:</span>
                        <span style="color: #0c0c0c; font-family: Arial, Helvetica, sans-serif;">
                            {{receta.cliente_nombre}}
                        </span>
                    </li>
                    <li>
                        <span class="font-weight-bold" style="text-decoration: underline;">FINCA:</span>
                        <span style="color: #0c0c0c; font-family: Arial, Helvetica, sans-serif;">
                            {{receta.finca}}
                        </span>
                    </li>
                </ul>
            </div>

            <div class="my-3" style="border: 1px solid #8f8f8f; outline: 1px #c5c5c5;">
                <ul class="p-0 m-0 ml-1" style="list-style: none; color: #006600;">
                    <li>
                        <span class="font-weight-bold" style="text-decoration: underline;">VARIEDAD(ES):</span>
                        <span style="color: #0c0c0c; font-family: Arial, Helvetica, sans-serif;">
                            {{receta.variedad}}
                        </span>
                    </li>
                    <li>
                        <span class="font-weight-bold" style="text-decoration: underline;">MOMENTO DE APLICACIÓN:</span>
                        <span style="color: #0c0c0c; font-family: Arial, Helvetica, sans-serif;">
                            {{receta.fecha_fin}}
                        </span>
                    </li>
                </ul>
            </div>

            <!-- Datos de los productos -->
            <div>
                <table class="table-pascual-cabedo my-4 mx-auto">
                    <tr class="font-weight-bold">
                        <td class="p-1" style="background:dimgrey; color:white;">PRODUCTO</td>
                        <td class="p-1" style="background:dimgrey; color:white;">DOSIS</td>
                        <td class="p-1" style="background:dimgrey; color:white;">GR./ÁRBOL (DOSIS/HA)</td>
                    </tr>
                    <ng-container *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
                        <tr *ngIf="receta['producto' + i]">
                            <td class="p-1">
                                {{receta['producto' + i]}}
                            </td>
                            <td class="p-1">
                                {{decimalFormat(+(receta['dosis' + i] || 0), 2)}}
                            </td>
                            <td class="p-1">
                                {{decimalFormat(+(receta['gramos' + i] || 0), 2)}}
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>

            <div class="my-1 p-1" style="color: #006600;">
                <div class="my-3">
                    <p style="font-style: italic; text-decoration: underline; font-size: 12pt;">
                        NOTAS:
                    </p>
                    <div class="p-3"
                        style="font-size: 10pt; color: #0c0c0c; font-family: Arial, Helvetica, sans-serif;">
                        {{receta.observaciones}}
                    </div>
                </div>
            </div>

            <div>
                <p class="mb-2 font-weight-bold" style="
                    font-style: italic;
                    font-size: 12pt;
                    font-family: 'Times New Roman', Times, serif;
                    text-decoration: underline;
                    color: #ff0000;">
                    OBSERVACIONES Y RECOMENDACIONES IMPORTANTES:
                </p>

                <div style="font-family: Arial, Helvetica, sans-serif; font-size: 10pt;">
                    LEER SIEMPRE LAS ETIQUETAS ANTES DEL USO DE LOS PRODUCTOS RECOMENDADOS.
                    <br />
                    <br />
                    <b>N</b>o sobrepasar las dosis recomendadas sin consultar al servicio técnico de esta empresa.
                    <br />
                    <b>N</b>o llenar los depósitos con restos anteriores.
                    <br />
                    <b>L</b>lenar siempre la mitad del depósito antes de aplicar los fertilizantes.
                    <br />
                    <b>D</b>isolver los polvos previamente en un cubo de agua.
                    <br />
                    <b>D</b>epositar los envases una vez vaciados en el punto SIGFITO de esta empresa.
                    <br />
                    <br />
                </div>

                <div class="pl-1 mb-2 w-100" style="
                    border: 1px solid #0c0c0c;
                    font-size: 10pt;
                    font-family: Arial, Helvetica, sans-serif;">
                    <b>S</b>e dispondrán de todas las medidas de Seguridad e Higiene en el trabajo según la normativa
                    vigente.
                </div>

                <div class="d-flex mt-2" style="
                    font-size: 12pt;
                    font-family: 'Times New Roman', Times, serif;
                    font-style: italic;
                    color: #008000;">
                    <div style="flex: 2;">
                        PRECIO DE COSTE POR CUBA DE 1.000,00
                    </div>
                    <div style="flex: 1">
                        € iva incluido.
                    </div>
                </div>
            </div>


        </div>

        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="showReceta = false;">Cerrar</button>
            <button class="btn btn-primary mx-2" (click)="imprimirReceta();">Imprimir</button>
        </div>
    </div>
    <br>

</p-dialog>

<!-- VERSIÓN "AgroGEST" -->
<p-dialog *ngIf="env.showRecetaFertiAgrogest" [(visible)]="showReceta" (onShow)="scrollToTop()" [modal]="true">

    <ng-template #header>
        <p class="fw-bold text-2xl">{{this.env.appName === 'yagoaznar' ? 'Impreso del Plan de Abonado' : 'Impreso de la receta'}}</p>
    </ng-template>

    <div *ngIf="receta" class="px-3" style="width: 100%;">
        <div id="html2canvasDiv">
            <div class="relative w-full text-xxl-start">
                <img [src]="env.logoUrl" style="width: 150px; height: auto;" alt="Logo">
            </div>
            <p class="text-2xl">Datos de la explotación</p>
            <p-table [value]="[receta]" stripedRows [tableStyle]="{'width':'100%'}" [autoLayout]="true" responsiveLayout="stack" [responsive]="true">
                <ng-template #header>
                    <tr>
                        <th>{{env.fincaName}}</th>
                        <th>{{env.sectoresName}}</th>
                        <th>{{env.parcelasName}}</th>
                    </tr>
                </ng-template>
                <ng-template #body let-receta>
                    <tr>
                        <td><span class="p-column-title fw-bold">{{env.fincaName}}</span> {{receta.finca}}</td>
                        <td><span class="p-column-title fw-bold">{{env.sectoresName}}</span> {{receta.sectores_nombres}}</td>
                        <td><span class="p-column-title fw-bold">{{env.parcelasName}}</span> {{receta.parcelas_nombres}}</td>
                    </tr>
                </ng-template>
            </p-table>

            <p class="text-2xl mt-2 fw-bold">Datos de la tarea</p>

            <p-table [value]="[receta]" stripedRows [tableStyle]="{'width':'100%'}" responsiveLayout="stack" [responsive]="true">
                <ng-template #header>
                    <tr>
                        <th>Tipo</th>
                        <th *ngIf="env.showFertilizantesAlbaranFactura">Albarán/factura</th>
                        <th>Horas</th>
                        <th>Días/semana</th>
                        <th>Inicio</th>
                        <th>Fin</th>
                    </tr>
                </ng-template>
                <ng-template #body let-receta>
                    <tr>
                        <td><span class="p-column-title fw-bold">Tipo</span> {{receta.tipo_fertilizacion}}</td>
                        <td *ngIf="env.showFertilizantesAlbaranFactura"><span class="p-column-title fw-bold">Albarán/factura</span> {{receta.albaran_factura}}</td>
                        <td><span class="p-column-title fw-bold">Horas</span> {{decimalFormat(+(receta.horas_totales || 0), 2)}}</td>
                        <td><span class="p-column-title fw-bold">Días/semana</span> {{receta.dias_semana_formatted}}</td>
                        <td><span class="p-column-title fw-bold">Inicio</span> {{receta.fecha_inicio}}</td>
                        <td><span class="p-column-title fw-bold">Fin</span> {{receta.fecha_fin}}</td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="w-full d-flex flex-row flex-wrap mt-2">
                <div class="w-75">
                    <p class="text-2xl fw-bold">Productos</p>

                    <table class="table table-bordered table-striped">
                        <thead>
                            <th>Nombre</th>
                            <th>Cantidad</th>
                            <th *ngIf="env.showTareasFertiGramos">Gr./árbol (dosis/{{env.textoSuperficie}})</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
                                <td *ngIf="receta['producto' + i]">{{receta['producto' + i]}}</td>
                                <td *ngIf="receta['producto' + i]">
                                    <span *ngIf="receta['dosis' + i] !== 0">
                                        {{decimalFormat(+(receta['dosis' + i] || 0), 2)}}
                                    </span>
                                </td>
                                <td *ngIf="receta['producto' + i] && env.showTareasFertiGramos">
                                    <span *ngIf="receta['gramos' + i] !== 0">
                                        {{decimalFormat(+(receta['gramos' + i] || 0), 2)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        
                <div *ngIf="env.showFertilizantesNPK" style="width: 30%;">
                    <p class="text-2xl fw-bold">Abonado</p>
                    <table class="table table-bordered table-striped">
                        <thead>
                            <th>N</th>
                            <th>P</th>
                            <th>K</th>
                            <th *ngIf="env.showFertilizantesCa">Ca</th>
                            <th *ngIf="env.showFertilizantesS">S</th>
                            <th *ngIf="env.showFertilizantesMg">Mg</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{decimalFormat(+(receta.n || 0), 2, '.', ',', 3)}}</td>
                                <td>{{decimalFormat(+(receta.p || 0), 2, '.', ',', 3)}}</td>
                                <td>{{decimalFormat(+(receta.k || 0), 2, '.', ',', 3)}}</td>
                                <td *ngIf="env.showFertilizantesCa">{{decimalFormat(+(receta.ca || 0), 2, '.', ',', 3)}}</td>
                                <td *ngIf="env.showFertilizantesS">{{decimalFormat(+(receta.s || 0), 2, '.', ',', 3)}}</td>
                                <td *ngIf="env.showFertilizantesMg">{{decimalFormat(+(receta.mg || 0), 2, '.', ',', 3)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="env.appName==='esparragosgranada'">
                <hr>
                <table class="table table-bordered table-striped table-hover table-receta">
                    <thead>
                        <th style="width: 33%;">Firma técnico</th>
                        <th style="width: 33%;">Recibí</th>
                        <th style="width: 33%;">Firma respons/Fecha aplicación</th>
                    </thead>
                </table>
            </div>
        </div>
    </div>



    <ng-template #footer>
        <div class="d-flex align-items-center flex-wrap gap-4 w-100 justify-content-center">
            <button class="btn btn-dark text-white align-self-center"
                [ngStyle]="{'width': navigationService.isMobileOrTablet() ? '40%' : 'auto'}"
                (click)="showReceta = false;">Cerrar</button>
            <button class="btn btn-primary text-white align-self-center"
                [ngStyle]="{'width': navigationService.isMobileOrTablet() ? '40%' : 'auto'}"
                (click)="imprimirReceta();">Imprimir</button>
            @if(env.showEnviarWhatsapp) {
            <button class="btn btn-success  text-white align-self-center" (click)="enviarWhatsapp()">
                <img style="height: 20px" src="./assets/whatsapp_48x48.png" alt="Icono WhatsApp">
                Enviar WhatsApp
            </button>
            }
            @if(env.showEnviarCorreo) {
            <button [disabled]="tareasApi.enviarRecetaCaptura.isLoading || isGeneratingCanvas || 
                                        !(receta.finca_email || receta.cliente_email)" (click)="enviarCorreo()"
                class="btn align-self-center mx-2"
                [ngClass]="tareasApi.enviarRecetaCaptura.hasError ? 'btn-danger' : 'btn-warning'" tooltipPosition="top"
                pTooltip="Se enviará la receta a este email">

                <ng-container
                    *ngIf="!tareasApi.enviarRecetaCaptura.isLoading && !tareasApi.enviarRecetaCaptura.hasError">
                    <i class="fa fa-envelope"></i>
                    <span *ngIf="isGeneratingCanvas">
                        Generando pdf...
                    </span>
                    <span *ngIf="!isGeneratingCanvas && (receta.finca_email || receta.cliente_email)">
                        Enviar a {{receta.finca_email ? receta.finca_email : receta.cliente_email}}
                    </span>
                    <span *ngIf="!isGeneratingCanvas && !(receta?.finca_email || receta?.cliente_email)">
                        Enviar email
                    </span>
                </ng-container>
                <ng-container
                    *ngIf="tareasApi.enviarRecetaCaptura.isLoading && !tareasApi.enviarRecetaCaptura.hasError">
                    <i class="fa fa-envelope"></i>
                    Enviando...
                </ng-container>
                <ng-container *ngIf="tareasApi.enviarRecetaCaptura.hasError">
                    <i class="fa fa-exclamation-triangle"></i>
                    {{tareasApi.enviarRecetaCaptura.error}}
                </ng-container>
            </button>
            }
        </div>
    </ng-template>
</p-dialog>

<a href="#" id="downloadReceta" style="visibility: hidden; position: fixed;"></a>
<!-- Modal filtrar campaña -->
<p-dialog [contentStyle]="{'min-height':'250px'}" header="Campaña" [closeOnEscape]="false" [closable]="false"
    [(visible)]="env.modalShowCampaign" (onShow)="scrollToTop()">

    <div>
        <div style="max-width: 200px;">

        </div>
        <br>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="closeModalShowCampaign();">Cerrar</button>
        </div>
        <br>
    </div>
</p-dialog>